import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';
import alertUserOfDeprecatedProps from '../../utils/deprecation.js';
import useCanvasId from '../../utils/useCanvasId.js';

var _excluded = ["className", "error", "disabled", "highlight", "id", "required"];
var InputMonth = function InputMonth(_ref, ref) {
  var className = _ref.className,
    error = _ref.error,
    disabled = _ref.disabled,
    highlight = _ref.highlight,
    id = _ref.id,
    required = _ref.required,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('InputMonth', otherProps);
  var finalClasses = classnames('C-Input --type-month', {
    isDisabled: disabled,
    isErrored: error,
    isHighlighted: highlight
  }, className);
  var uuid = useCanvasId(id, 'Month');
  return /*#__PURE__*/React__default.createElement("input", _extends({
    className: finalClasses,
    disabled: disabled,
    type: "month",
    role: "textbox",
    id: id ? id : uuid,
    ref: ref,
    required: required,
    "aria-required": required ? 'true' : 'false'
  }, otherProps));
};
InputMonth.displayName = 'Input.Month';
var InputMonth$1 = /*#__PURE__*/React__default.forwardRef(InputMonth);

export { InputMonth$1 as default };
